import cookies from 'react-cookies';
import { batch } from 'react-redux';

import { changeSelectedSlotState, flushHour, setIsLoading, updateHoursForDay } from '@r1-frontend/service-engineer-visit/actions/simple';
import { PROVIDER_ID_COOKIE } from '@r1-frontend/service-engineer-visit/constants';
import { TContextDispatch } from '@r1-frontend/service-engineer-visit/context/Context';
import { dataLayerPush, transformTimeSlots } from '@r1-frontend/service-engineer-visit/helpers';
import { TInitialState } from '@r1-frontend/service-engineer-visit/reducer/initialState';
import getBodyForTimeSlotsRequest from '@r1-frontend/service-engineer-visit/selectors/getBodyForTimeSlotsRequest';
import getConfirmBody from '@r1-frontend/service-engineer-visit/selectors/getConfirmBody';
import { TGetTimeSlots } from '@r1-frontend/service-engineer-visit/types/TGetTimeSlots';
import { TReturnType } from '@r1-frontend/service-engineer-visit/types/TReturnType';

const onConfirm = (
    domain = '',
    confirmCallback: (result: TReturnType | null) => void,
    getTimeSlotsFunc: TGetTimeSlots,
    productId?: number,
    gaLabel?: string,
) => async(dispatch: TContextDispatch, getState: () => TInitialState) => {
    const {
        _incomingData,
        selected: {
            date,
            hour,
        },
        slots: stateSlots,
    } = getState();

    const providerId = cookies.load(PROVIDER_ID_COOKIE);

    if (!_incomingData) {
        throw new Error('Incoming data is not set');
    }

    if (!date || !hour) {
        return;
    }

    dispatch(setIsLoading(true));

    const body = getBodyForTimeSlotsRequest(getState(), date, date, productId);

    const resp = await getTimeSlotsFunc(providerId, body);

    dataLayerPush({
        category: _incomingData.gaCategory || '',
        action: `request_connection_${!resp.isSuccess ? 'error' : 'success'}`,
        label: gaLabel,
    });

    if (!resp.isSuccess) {
        dataLayerPush({
            category: _incomingData.gaCategory,
            action: 'request connection',
            label: `error ${resp.error.message} ${domain}`,
        });
        batch(() => {
            dispatch(changeSelectedSlotState(false));
            dispatch(setIsLoading(false));
            dispatch(flushHour());
        });
    } else {
        const response = transformTimeSlots(Object.values(resp.payload.timeSlots));
        if (!response || !response[date]) {
            batch(() => {
                dispatch(changeSelectedSlotState(false));
                dispatch(setIsLoading(false));
                dispatch(flushHour());
            });
            return;
        }

        const selectedHourFromResponse = response[date].hours[hour];

        if (selectedHourFromResponse.active) {
            dispatch(changeSelectedSlotState(true));
            confirmCallback(getConfirmBody(getState()));
        } else {
            const updatedHours = JSON.parse(JSON.stringify(stateSlots[date].hours));
            updatedHours[hour].active = false;

            batch(() => {
                dispatch(updateHoursForDay(date, updatedHours));
                dispatch(changeSelectedSlotState(false));
                dispatch(setIsLoading(false));
                dispatch(flushHour());
            });
        }
    }
};

export default onConfirm;
